__turbopack_context__.v({
  "after": "lpMoov-module__iwRB9G__after",
  "appGlow": "lpMoov-module__iwRB9G__appGlow",
  "appGrid": "lpMoov-module__iwRB9G__appGrid",
  "appStage": "lpMoov-module__iwRB9G__appStage",
  "before": "lpMoov-module__iwRB9G__before",
  "bottomTile": "lpMoov-module__iwRB9G__bottomTile",
  "bullet": "lpMoov-module__iwRB9G__bullet",
  "bulletIcon": "lpMoov-module__iwRB9G__bulletIcon",
  "bulletList": "lpMoov-module__iwRB9G__bulletList",
  "checkItem": "lpMoov-module__iwRB9G__checkItem",
  "checkList": "lpMoov-module__iwRB9G__checkList",
  "container": "lpMoov-module__iwRB9G__container",
  "continuityPath": "lpMoov-module__iwRB9G__continuityPath",
  "coreCenter": "lpMoov-module__iwRB9G__coreCenter",
  "coreGrid": "lpMoov-module__iwRB9G__coreGrid",
  "cost": "lpMoov-module__iwRB9G__cost",
  "costBody": "lpMoov-module__iwRB9G__costBody",
  "costGrid": "lpMoov-module__iwRB9G__costGrid",
  "costIcon": "lpMoov-module__iwRB9G__costIcon",
  "costItem": "lpMoov-module__iwRB9G__costItem",
  "costList": "lpMoov-module__iwRB9G__costList",
  "eyebrow": "lpMoov-module__iwRB9G__eyebrow",
  "fadeRise": "lpMoov-module__iwRB9G__fadeRise",
  "faq": "lpMoov-module__iwRB9G__faq",
  "faqHead": "lpMoov-module__iwRB9G__faqHead",
  "faqItem": "lpMoov-module__iwRB9G__faqItem",
  "faqList": "lpMoov-module__iwRB9G__faqList",
  "final": "lpMoov-module__iwRB9G__final",
  "finalGrid": "lpMoov-module__iwRB9G__finalGrid",
  "finalSoft": "lpMoov-module__iwRB9G__finalSoft",
  "fit": "lpMoov-module__iwRB9G__fit",
  "fitGrid": "lpMoov-module__iwRB9G__fitGrid",
  "focusCard": "lpMoov-module__iwRB9G__focusCard",
  "focusCardIcon": "lpMoov-module__iwRB9G__focusCardIcon",
  "footer": "lpMoov-module__iwRB9G__footer",
  "footerInner": "lpMoov-module__iwRB9G__footerInner",
  "fragment": "lpMoov-module__iwRB9G__fragment",
  "fragmentList": "lpMoov-module__iwRB9G__fragmentList",
  "glowPulse": "lpMoov-module__iwRB9G__glowPulse",
  "header": "lpMoov-module__iwRB9G__header",
  "headerCta": "lpMoov-module__iwRB9G__headerCta",
  "headerDrop": "lpMoov-module__iwRB9G__headerDrop",
  "headerInner": "lpMoov-module__iwRB9G__headerInner",
  "heading": "lpMoov-module__iwRB9G__heading",
  "hero": "lpMoov-module__iwRB9G__hero",
  "heroCard": "lpMoov-module__iwRB9G__heroCard",
  "heroCardAi": "lpMoov-module__iwRB9G__heroCardAi",
  "heroCardBoard": "lpMoov-module__iwRB9G__heroCardBoard",
  "heroCardChat": "lpMoov-module__iwRB9G__heroCardChat",
  "heroCardFlow": "lpMoov-module__iwRB9G__heroCardFlow",
  "heroCopy": "lpMoov-module__iwRB9G__heroCopy",
  "heroCta": "lpMoov-module__iwRB9G__heroCta",
  "heroDriftA": "lpMoov-module__iwRB9G__heroDriftA",
  "heroDriftB": "lpMoov-module__iwRB9G__heroDriftB",
  "heroDriftC": "lpMoov-module__iwRB9G__heroDriftC",
  "heroDriftD": "lpMoov-module__iwRB9G__heroDriftD",
  "heroGrid": "lpMoov-module__iwRB9G__heroGrid",
  "heroNote": "lpMoov-module__iwRB9G__heroNote",
  "heroStage": "lpMoov-module__iwRB9G__heroStage",
  "heroVisual": "lpMoov-module__iwRB9G__heroVisual",
  "lead": "lpMoov-module__iwRB9G__lead",
  "leadGreen": "lpMoov-module__iwRB9G__leadGreen",
  "logo": "lpMoov-module__iwRB9G__logo",
  "logoButton": "lpMoov-module__iwRB9G__logoButton",
  "logoDark": "lpMoov-module__iwRB9G__logoDark",
  "mutedBig": "lpMoov-module__iwRB9G__mutedBig",
  "pathItem": "lpMoov-module__iwRB9G__pathItem",
  "phone": "lpMoov-module__iwRB9G__phone",
  "phoneFloatLeft": "lpMoov-module__iwRB9G__phoneFloatLeft",
  "phoneFloatMain": "lpMoov-module__iwRB9G__phoneFloatMain",
  "phoneFloatRight": "lpMoov-module__iwRB9G__phoneFloatRight",
  "phoneLeft": "lpMoov-module__iwRB9G__phoneLeft",
  "phoneMain": "lpMoov-module__iwRB9G__phoneMain",
  "phoneRight": "lpMoov-module__iwRB9G__phoneRight",
  "platformPanel": "lpMoov-module__iwRB9G__platformPanel",
  "platformTile": "lpMoov-module__iwRB9G__platformTile",
  "platformTileIcon": "lpMoov-module__iwRB9G__platformTileIcon",
  "revealBlock": "lpMoov-module__iwRB9G__revealBlock",
  "revealIn": "lpMoov-module__iwRB9G__revealIn",
  "section": "lpMoov-module__iwRB9G__section",
  "sectionHead": "lpMoov-module__iwRB9G__sectionHead",
  "sideCol": "lpMoov-module__iwRB9G__sideCol",
  "sideLeft": "lpMoov-module__iwRB9G__sideLeft",
  "sideRight": "lpMoov-module__iwRB9G__sideRight",
  "stagger": "lpMoov-module__iwRB9G__stagger",
  "statCard": "lpMoov-module__iwRB9G__statCard",
  "statsGrid": "lpMoov-module__iwRB9G__statsGrid",
  "symptomCard": "lpMoov-module__iwRB9G__symptomCard",
  "symptomNumber": "lpMoov-module__iwRB9G__symptomNumber",
  "symptomQuestion": "lpMoov-module__iwRB9G__symptomQuestion",
  "symptomsGrid": "lpMoov-module__iwRB9G__symptomsGrid",
  "topTile": "lpMoov-module__iwRB9G__topTile",
  "transformArrow": "lpMoov-module__iwRB9G__transformArrow",
  "transformCard": "lpMoov-module__iwRB9G__transformCard",
  "transformFoot": "lpMoov-module__iwRB9G__transformFoot",
  "transformGrid": "lpMoov-module__iwRB9G__transformGrid",
  "videoFrame": "lpMoov-module__iwRB9G__videoFrame",
  "videoHead": "lpMoov-module__iwRB9G__videoHead",
  "whatsappCard": "lpMoov-module__iwRB9G__whatsappCard",
  "whatsappCta": "lpMoov-module__iwRB9G__whatsappCta",
  "whatsappNote": "lpMoov-module__iwRB9G__whatsappNote",
  "why": "lpMoov-module__iwRB9G__why",
  "whyCopy": "lpMoov-module__iwRB9G__whyCopy",
  "whyGrid": "lpMoov-module__iwRB9G__whyGrid",
});
